import { Component, Input, OnInit } from '@angular/core';
import { SupaService } from '../../../services/supa.service';
import { ModalController } from '@ionic/angular';
import { HelperService } from '../../../services/helper.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'dia-tyrebrands',
  template: `
    <ion-header translucent>
      <ion-toolbar mode='md'>
        <ion-title>{{id == null ? 'New' : 'Edit'}} tyre brand</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="save()">
            <ion-icon slot="icon-only" name="save"></ion-icon>
          </ion-button>
          <ion-button (click)="dismissModal()">
            <ion-icon slot="icon-only" name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content mode='md' *ngIf="(isDoneLoading|async); else loading" fullscreen>
      <ion-list>
        <ion-item>
          <ion-label position="floating">Brand name</ion-label>
          <ion-input [(ngModel)]="name"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="floating">Thread depth amber (mm)</ion-label>
          <ion-input type="number" [(ngModel)]="amberdepthmm"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="floating">Thread depth red (mm)</ion-label>
          <ion-input type="number" [(ngModel)]="reddepthmm"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="floating">Expire years</ion-label>
          <ion-input type="number" (ngModelChange)="daysFromYear($event)" [(ngModel)]="expireyears"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="floating">Expire days</ion-label>
          <ion-input type="number" (ngModelChange)="expireyears=$event/365"  [(ngModel)]="expiredays"></ion-input>
        </ion-item>
        <ion-item detail button (click)="uploader.click()">
          <ion-label color="primary">Upload new logo</ion-label>
        </ion-item>
        <input hidden type="file" #uploader (change)="uploadPicture($event)" />
        <ion-item button detail (click)="delete()">
          <ion-label color="danger">Delete brand</ion-label>
        </ion-item>
      </ion-list>

      <div class="ion-padding">
        <h3>Logo preview</h3>
        <br />
        <img src="{{logo}}" alt="Tyre logo" style="max-width:500px; max-height: 130px;border: 1px solid #e7e7e7; margin-bottom: 20px;">
      </div>
    </ion-content>

    <ng-template #loading>
      <ion-content class="ion-padding">
        <ion-spinner></ion-spinner>
      </ion-content>
    </ng-template>
  `,
  styles: [],
})
export class TyrebrandsDialog implements OnInit {

  isDoneLoading = new BehaviorSubject<boolean>(undefined);
  uploadNewPic = false;

  parentShouldReload=false

  @Input('id') id = null;

  name = ""
  logo = "data:image/png;base64,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"
  expiredays = 0
  expireyears = 0
  amberdepthmm = 5
  reddepthmm = 2.5

  constructor(private supa: SupaService, private modalController: ModalController, private helper: HelperService) { }

  ngOnInit() {
    if (this.id != null) {
      this.init()
    } else {
      this.isDoneLoading.next(true);
    }
  }

  daysFromYear(e) {
    this.expiredays = Math.round(e * 365);
  }

  delete() {
    this.helper.promptYesNo('Delete brand', 'Do you want to delete this brand?', async ()=>{
      this.isDoneLoading.next(false);
      let {data, error} = await this.supa.supabase.from('vhc_tyrebrand').delete().eq('id', this.id);
      if (error) {
        this.helper.notify('Could not delete tyre brand', 'danger');
        this.isDoneLoading.next(true);
        console.log(error);
      } else {
        this.helper.notify('The brand was deleted', 'success');
        this.parentShouldReload = true;
        this.dismissModal();
      }
    }, 'delete')
  }

  dismissModal() {
    this.modalController.dismiss({parentShouldReload: this.parentShouldReload});
  }

  uploadPicture(event) {
    if (event.target.files == undefined){
      this.helper.notify("Please upload a file", 'warning')
      return;
    }
    if (event.target.files[0] == undefined){
      this.helper.notify("Please upload a file", 'warning')
      return;
    }
    if (event.target.files[0].type == undefined){
      this.helper.notify("Please upload a file", 'warning')
      return;
    }
    if (!event.target.files[0].type.includes("image")){
      this.helper.notify("Please upload an image", 'warning')
      return;
    }
    if (event.target.files[0].size == undefined){
      this.helper.notify("Please upload an image", 'warning')
      return;
    }
    if (event.target.files[0].size / 1024 > 100){
      this.helper.notify("The image should be smaller then 100KB", 'warning')
      return;
    }

    let file = event.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      console.log(reader.result);
      this.logo = reader.result.toString();
      this.uploadNewPic = true;
      this.helper.notify("Loaded image successfully", 'success');
    };
    reader.onerror = (error) => {
      console.log('Error: ', error);
      this.helper.notify("Could not load image", 'danger')
    };
  }

  async init() {
    console.log('init');
    let { data, error } = await this.supa.supabase.from('vhc_tyrebrand').select('*').eq('id', this.id).single();
    console.log(data);
    this.name = data.name;
    this.logo = data.logo;
    this.expiredays = data.expiredays;
    this.amberdepthmm = data.amberdepthmm;
    this.reddepthmm = data.reddepthmm;
    this.expireyears = data.expiredays / 365
    this.isDoneLoading.next(true);
  }

  async save() {
    this.parentShouldReload=true
    if (!this.id) {
      this.isDoneLoading.next(false)
      let {data, error} = await this.supa.supabase.from('vhc_tyrebrand').insert({
        logo: this.logo,
        expiredays: this.expiredays,
        name: this.name
      }).select().single();
      if (!error) {
        this.helper.notify('Tyrebrand saved successfully', 'success')
        this.dismissModal();
      } else {
        console.log(error);
        this.helper.notify('Could not save tyrebrand', 'danger');
      }
      this.isDoneLoading.next(true)
      this.id = data.id;
    } else {
      this.isDoneLoading.next(false)
      let {data, error} = await this.supa.supabase.from('vhc_tyrebrand').update(
          this.uploadNewPic ? {
            logo: this.logo,
            expiredays: this.expiredays,
            amberdepthmm: this.amberdepthmm,
            reddepthmm: this.reddepthmm,
            name: this.name
          } : {
            expiredays: this.expiredays,
            name: this.name
          }
        ).eq('id', this.id).single();
      if (!error) {
        this.helper.notify('Tyrebrand saved successfully', 'success')
        this.dismissModal();
      } else {
        console.log(error);
        this.helper.notify('Could not save tyrebrand', 'danger');
      }
      this.isDoneLoading.next(true)
    }
  }

}
